import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import { PortalReportsApi } from '../../../api/portalReports';

/**
 * Modal para renombrar / editar descripción de una vista guardada existente.
 * Hace PATCH /data-explorer-views/{id}/ con { name, description }. NO toca el config
 * ni el assignment al portal.
 */
class EditViewMetadataModalComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            description: '',
            isSaving: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.isOpen && !prevProps.isOpen && this.props.view) {
            this.setState({
                name: this.props.view.name || '',
                description: this.props.view.description || '',
                isSaving: false,
            });
        }
    }

    handleSave = () => {
        const { t, view, onSaved, toggle } = this.props;
        const trimmedName = this.state.name.trim();
        const description = this.state.description.trim();

        if (!trimmedName) {
            toast.error(t('saved_views.name_required'));
            return;
        }
        if (!view || !view.id) return;

        this.setState({ isSaving: true });

        PortalReportsApi.updateView(view.id, {
            name: trimmedName,
            description: description || null,
        }).then((response) => {
            if (!response || response.status === 'ERROR') {
                const msg = (response && response.error_message) || t('saved_views.save_error');
                toast.error(msg);
                this.setState({ isSaving: false });
                return;
            }
            toast.success(t('saved_views.metadata_updated'));
            this.setState({ isSaving: false });
            if (onSaved) {
                onSaved({
                    ...view,
                    name: trimmedName,
                    description: description || null,
                });
            }
            toggle();
        }).catch(() => {
            toast.error(t('saved_views.save_error'));
            this.setState({ isSaving: false });
        });
    };

    render() {
        const { t, isOpen, toggle, view } = this.props;
        const { name, description, isSaving } = this.state;

        if (!view) return null;
        const canSubmit = name.trim().length > 0 && !isSaving;

        return (
            <Modal isOpen={isOpen} toggle={isSaving ? undefined : toggle}>
                <ModalHeader toggle={isSaving ? undefined : toggle}>
                    {t('saved_views.edit_metadata_title')}
                </ModalHeader>
                <ModalBody>
                    <div className="modal-section">
                        <div className="form-row">
                            <label>{t('saved_views.name_label')}</label>
                            <input
                                type="text"
                                className="form-control"
                                value={name}
                                onChange={(e) => this.setState({ name: e.target.value })}
                                placeholder={t('saved_views.name_placeholder')}
                                autoFocus
                                disabled={isSaving}
                                maxLength={200}
                            />
                        </div>
                        <div className="form-row">
                            <label>{t('saved_views.description_label')}</label>
                            <textarea
                                className="form-control"
                                rows={3}
                                value={description}
                                onChange={(e) => this.setState({ description: e.target.value })}
                                disabled={isSaving}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle} disabled={isSaving}>
                        {t('common.cancel')}
                    </Button>
                    <button className="btn -alt" onClick={this.handleSave} disabled={!canSubmit}>
                        {isSaving ? t('common.saving') : t('saved_views.save')}
                    </button>
                </ModalFooter>
            </Modal>
        );
    }
}

export const EditViewMetadataModal = withTranslation()(EditViewMetadataModalComponent);
